import { Image } from "react-grid-gallery";

import TestImg from "@/public/png/itinerary/srilanka/hakgala-botanical-garde.jpg";
import TestImg1 from "@/public/png/itinerary/srilanka/colombo-museum.jpg";
import TestImg2 from "@/public/png/itinerary/srilanka/ramboda-falls.jpg";
import TestImg3 from "@/public/png/itinerary/srilanka/pinnawala-elephant.jpg";


import TestImgs from "@/public/png/itinerary/srilanka/madu-river-boat-ride.jpg";
import TestImg4 from "@/public/png/itinerary/srilanka/temple-of-the-tooth.jpg";

export interface CustomImage extends Image {
    original: string;
}

export const images: CustomImage[] = [
    {
        src: TestImgs.src,
        original: TestImg.src,
        width: 320,
        height: 174,
        tags: [
            { value: "Nature", title: "Nature" },
            { value: "Flora", title: "Flora" },
        ],
        caption: "",
    },
    {
        src: TestImg1.src,
        original:
            TestImg1.src,
        width: 636,
        height: 224,
        caption: "",
    },
    {
        src: TestImg2.src,
        original:
            TestImg2.src,
        width: 318,
        height: 216,
        caption: "",
    },
    {
        src: TestImg3.src,
        original:
            TestImg3.src,
        width: 318,
        height: 216,
        caption: "",
    },
    {
        src: TestImg4.src,
        original:
            TestImg4.src,
        width: 320,
        height: 183,
        caption: "",
    },

];
